const mergeWith = require('lodash/mergeWith');
const equalsOrNull = require('./equalsOrNull');

module.exports = (object, source, exceptions) => mergeWith(object, source, equalsOrNull(exceptions));
